// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import get from 'lodash/get';

// function that takes in the component config for a QueryParamSection and the queryParams active on the current page
// and verifies whether or not this component is currently rendered so that we know whether or not to load / fetch data
export default (componentConfig, queryParams) => {
  const queryToWatch = get(componentConfig, 'props.queryToWatch');
  const requiredQueryValue = get(
    componentConfig,
    'props.requiredQueryValue',
    ''
  );
  return get(queryParams, queryToWatch, '') === requiredQueryValue;
};
